// extracted by mini-css-extract-plugin
module.exports = {"rotate":"loading-icon_rotate__1kBKc","rot":"loading-icon_rot__dzJbA"};